import * as reportApi from "@/api/report";
import { RiskReportRequest, SentinelaReportRequest } from "@/api/report/types";
import { AxiosResponse } from "axios";

export const downloadSentinelaReport = async (request: SentinelaReportRequest) => {
  const response = await reportApi.getSentinelaReport(request);
  downloadFromResponse(response);
}

export const downloadDocToCarReport= async (request: string[]) => {
  const response = await reportApi.getDocumentToCarReport(request);
  downloadFromResponse(response);
}

export const downloadDocToEgReport= async (request: string[]) => {
  const response = await reportApi.getDocumentToEgReport(request);
  downloadFromResponse(response);
}

export const downloadRiskReport = async(request: RiskReportRequest) => {
  const response = await reportApi.getRiskReport(request);
  downloadFromResponse(response);
}

function downloadFromResponse(response: AxiosResponse<Blob>) {
  const filename = response.headers['content-disposition'].split('filename=')[1].split(';')[0];

  const blob = new Blob([response.data]);
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');

  link.download = filename;
  link.href = url;
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}

